import React, { useState } from 'react';
import ScrollReveal from '../components/ScrollReveal';
import BioModal from '../components/BioModal';
import './Agency.css';
import SEO, { seoConfig } from '../components/SEO';

export default function Agency({ t, language }) {
  const [bioModalOpen, setBioModalOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  const openBio = (member) => {
    setSelectedMember(member);
    setBioModalOpen(true);
  };

  const closeBio = () => {
    setBioModalOpen(false);
    setSelectedMember(null);
  };

  return (
    <div className="agency-page">
      {/* SEO Component */}
      <SEO 
        title={seoConfig.agency.title}
        description={seoConfig.agency.description}
        keywords={seoConfig.agency.keywords}
      />

      <div className="page-container">
        <ScrollReveal>
          <h1 className="page-title">{t.agency.title}</h1>
        </ScrollReveal>

        {/* Presentation */}
        <ScrollReveal delay={0.2}>
          <section className="agency-section">
            <div className="content-grid">
              <div>
                <h2 className="section-heading">{t.agency.presentation}</h2>
                <p className="section-text">{t.agency.presentationText}</p>
              </div>
              <div className="image-container">
                <img
                  src="/images/projets/ovalie/1.webp"
                  alt="Résidence Park View ZAC Ovalie Montpellier - Logements collectifs par Daniela Parito Architecture"
                  className="section-image"
                />
              </div>
            </div>
          </section>
        </ScrollReveal>

        {/* Philosophy */}
        <ScrollReveal delay={0.3}>
          <section className="agency-section">
            <div className="content-grid reverse">
              <div className="image-container order-2">
                <img
                  src="/images/projets/logements-frontignan/1.webp"
                  alt="Logements collectifs Frontignan - Architecture méditerranéenne par DP Architecture Montpellier"
                  className="section-image"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <div className="order-1">
                <h2 className="section-heading">{t.agency.philosophy}</h2>
                <p className="section-text">{t.agency.philosophyText}</p>
              </div>
            </div>
            <p className="section-text philo-text">{t.agency.philosophyText2}</p>
          </section>
        </ScrollReveal>

        {/* Society */}
        <ScrollReveal delay={0.4}>
          <section className="agency-section centered">
            <h2 className="section-heading centered">{t.agency.society}</h2>
            <p className="section-text centered">{t.agency.societyText}</p>
          </section>
        </ScrollReveal>

        {/* Team Section */}
        <ScrollReveal delay={0.5}>
          <section className="agency-section">
            <h2 className="section-heading centered">{t.agency.team}</h2>
            
            <div className="team-container">
              {t.agency.teamMembers.map((member, idx) => (
                <div key={idx} className="team-member">
                  <div className="team-grid">
                    <div className="team-photo">
                      <div className="photo-placeholder">
                        <img
                          src="/images/portrait/1.webp"
                          alt={member.name}
                          className="section-image"
                          loading='lazy'
                        />
                      </div>
                    </div>
                    
                    <div className="team-info">
                      <div className="team-details">
                        <h3 className="team-name">{member.name}</h3>
                        <p className="team-role">{member.role}</p>
                      </div>
                      
                      {/* Résumé bio */}
                      {member.summary && (
                        <p className="team-summary">{member.summary}</p>
                      )}
                      
                      <button 
                        className="bio-button"
                        onClick={() => openBio(member)}
                      >
                        Bio
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </ScrollReveal>

        {/* Texte introductif collaborateurs */}
        <ScrollReveal delay={0.55}>
          <section className="agency-section centered">
            <div className="collaboration-intro">
              <p className="section-text text-margin centered">
                {t.agency.collaborationIntro.paragraph1}
              </p>
              <p className="section-text centered">
                {t.agency.collaborationIntro.paragraph2}
              </p>
              <p className="section-text centered">
                {t.agency.collaborationIntro.paragraph3}
              </p>
            </div>
          </section>
        </ScrollReveal>

        {/* Partners Section */}
        <ScrollReveal delay={0.6}>
          <section className="agency-section">
            <h2 className="section-heading centered">{t.agency.partners}</h2>
            
            <div className="partners-container">
              <div className="partners-grid">
                <div>
                  <p className="partner-item"><span className="partner-name">Hugues BERANGER</span> - Architecte DE</p>
                  <p className="partner-item"><span className="partner-name">Robert KOR</span> - Architecte DPLG / BIM Manager</p>
                  <p className="partner-item"><span className="partner-name">Pierre BERANGER</span> - Architecte DPLG / Images 3D</p>
                </div>
                <div>
                  <p className="partner-item"><span className="partner-name">Monique ROUSSELOT</span> - Infographiste / Rendu images</p>
                  <p className="partner-item"><span className="partner-name">Jean-Charles MARINOT (EXEOP)</span> - Économiste / Maître d'œuvre d'exécution / OPC</p>
                </div>
              </div>
            </div>
          </section>
        </ScrollReveal>

        {/* BET Section */}
        <ScrollReveal delay={0.65}>
          <section className="agency-section">
            <h2 className="section-heading centered">{t.agency.bet}</h2>
            
            <div className="partners-container2">
              <div className="">
                <div>
                  <p className="partner-item"><span className="partner-name">BET {t.agency.structure}</span> - VERDIER, ITS 3.0, AGI TECHNIQUE, PER Ingénierie</p>
                  <p className="partner-item"><span className="partner-name">BET {t.agency.fluides}</span> - DELORME, DURAND, BETSO</p>
                  <p className="partner-item"><span className="partner-name">BET VRD</span> - SERI, RELIEF GE</p>
                  <p className="partner-item"><span className="partner-name">BET Démolition / {t.agency.desamiantage}</span> - ANTEA</p>
                </div>
              </div>
            </div>
          </section>
        </ScrollReveal>

        {/* Logiciels Section */}
        {/* <ScrollReveal delay={0.7}>
          <section className="agency-section">
            <h2 className="section-heading centered">{t.agency.logiciels}</h2>
            
            <div className="partners-container2">
              <div className="partners-grid">
                <div>
                  <p className="partner-item"><span className="partner-name">OS</span> - MAC</p>
                  <p className="partner-item"><span className="partner-name">VectorWorks 2022</span> - CAD</p>
                  <p className="partner-item"><span className="partner-name">AutoCAD Light</span> - Dessin technique</p>
                  <p className="partner-item"><span className="partner-name">Google SketchUp</span> - Modélisation 3D</p>
                </div>
                <div>
                  <p className="partner-item"><span className="partner-name">Adobe Acrobat</span> - PDF</p>
                  <p className="partner-item"><span className="partner-name">Adobe Photoshop</span> - Retouche image</p>
                  <p className="partner-item"><span className="partner-name">Adobe InDesign</span> - Mise en page</p>
                  <p className="partner-item"><span className="partner-name">Adobe Illustrator</span> - Design vectoriel</p>
                </div>
              </div>
            </div>
          </section>
        </ScrollReveal> */}
      </div>

      {/* Bio Modal */}
      {selectedMember && (
        <BioModal
          isOpen={bioModalOpen}
          onClose={closeBio}
          member={selectedMember}
          t={t}
          language={language}
        />
      )}
    </div>
  );
}